"use client"

import { useState } from "react"

type Props = {
  children: React.ReactNode
}

// On mobile, the filter sidebar is hidden behind a toggle button so users
// can reach products without scrolling past a long filter column. On the
// `small:` breakpoint and up it's always visible inline.
export default function MobileFilterToggle({ children }: Props) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-controls="category-filters-panel"
        className="small:hidden inline-flex items-center justify-between gap-3 w-full rounded-[10px] border border-aov-border bg-white px-4 py-3 mb-4 text-sm font-bold text-aov-navy shadow-[0_1px_3px_rgba(27,42,74,0.04)]"
      >
        <span className="inline-flex items-center gap-2">
          <svg
            className="w-4 h-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <line x1="21" y1="4" x2="14" y2="4" />
            <line x1="10" y1="4" x2="3" y2="4" />
            <line x1="21" y1="12" x2="12" y2="12" />
            <line x1="8" y1="12" x2="3" y2="12" />
            <line x1="21" y1="20" x2="16" y2="20" />
            <line x1="12" y1="20" x2="3" y2="20" />
            <line x1="14" y1="2" x2="14" y2="6" />
            <line x1="8" y1="10" x2="8" y2="14" />
            <line x1="16" y1="18" x2="16" y2="22" />
          </svg>
          {open ? "Hide filters" : "Filter & sort"}
        </span>
        <svg
          className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      <div
        id="category-filters-panel"
        className={`${open ? "block" : "hidden"} small:block`}
      >
        {children}
      </div>
    </>
  )
}
